import { render } from "./ActivationAccordions.vue?vue&type=template&id=6bd483be"
import script from "./ActivationAccordions.vue?vue&type=script&lang=js"
export * from "./ActivationAccordions.vue?vue&type=script&lang=js"

import "@/components/img.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/appl/bamboo/bamboo-agent-home-5/xml-data/build-dir/PORTAL-DREITVWEBUI-JOB1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__